<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <t4-container title="{{ 'Turbo.Settings.ConnectLockDialog.ConnectDeviceHeadline' | translate : 'Connect a device' }}"  [isLoading]="isLoading">
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.Settings.ConnectLockDialog.DeviceType' | translate : 'Device type'}}:</mat-label>
          <mat-select [(ngModel)]="deviceType" [required] (ngModelChange)="onTypeChange($event)">
            <mat-option [value]="0">{{ 'Turbo.Settings.ConnectLockDialog.Lock' | translate : 'Lock'}}</mat-option>
            <mat-option [value]="1">{{ 'Turbo.Settings.ConnectLockDialog.Tracker' | translate : 'Tracker'}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12" *ngIf="deviceType == 0">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.Settings.ConnectLockDialog.LockId' | translate : 'Lock id' }}</mat-label>
          <input matInput placeholder="{{ 'Turbo.Settings.ConnectLockDialog.LockId' | translate : 'Lock id' }} (Example: ABC-DEF-GHIJ)" [matAutocomplete]="acLockId" [formControl]="txtLockId" (keyup.enter)="close()">
          <mat-autocomplete #acLockId="matAutocomplete">
            <mat-option *ngFor="let lock of filteredLocks | async" [value]="lock.SerialId">
              <span>{{lock.SerialId}}</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col-12" *ngIf="deviceType == 1">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Turbo.Settings.ConnectLockDialog.Tracker' | translate : 'Tracker number' }}</mat-label>
          <input matInput placeholder="{{ 'Turbo.Settings.ConnectLockDialog.Tracker' | translate : 'Tracker number' }}" [matAutocomplete]="acTrackerId" [formControl]="txtTrackerId" (keyup.enter)="close()">
          <mat-autocomplete #acTrackerId="matAutocomplete">
            <mat-option *ngFor="let lock of filteredTrackers | async" [value]="lock.SerialId">
              <span>{{lock.SerialId}}</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
  </t4-container>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" style="margin: 5px;" [disabled]="(txtLockId.value == '' && txtTrackerId.value == '') || isLoading" (click)="connect()">{{ 'Turbo.Settings.ConnectLockDialog.cmdConnect' | translate : 'Connect' }}</button>
</mat-dialog-actions>
